import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import './loader.scss';

const Loader = ({ className, instant }) => {
  const [showLoader, setShowLoader] = useState(!!instant);
  useEffect(() => {
    if (instant) return;
    let timeout;
    timeout = setTimeout(() => {
      setShowLoader(true);
    }, 300);
    return () => clearTimeout(timeout);
  }, [instant]);

  if (!showLoader) return null;

  return (
    <div data-test-id="ig-spinner" className={classNames('ig-bullet-loader-container', className)}>
      <div className="ig-bullet-loader-col">
        <div className="ig-bullet-loader" />
      </div>
    </div>
  );
};

export default Loader;
